import _ from "lodash";
import {
  AUTH,
  NOTIFICATION,
  USER,
  USER_PREFERENCES,
} from "../_constants/actionConstants";

const initialState = {
  loggedIn: false,
  user: null, // userDto with projectRoles and notifications
  fetching: false,
  loggingIn: false,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case USER_PREFERENCES.FETCH:
    case USER_PREFERENCES.SAVE:
    case USER_PREFERENCES.SAVE_FULFILLED:
    case USER.FETCH_PROJECT_ROLES:
    case NOTIFICATION.FETCH_NOTIFICATIONS:
      return { ...state, fetching: true };

    case USER_PREFERENCES.FETCH_REJECTED:
    case USER_PREFERENCES.SAVE_REJECTED:
    case USER.FETCH_PROJECT_ROLES_REJECTED:
      return { ...state, fetching: false };

    case AUTH.LOGIN_REQUEST:
      return { ...state, loggingIn: true };

    case AUTH.LOGIN_SUCCESS:
      return {
        ...state,
        loggedIn: true,
        loggingIn: false,
        user: action.user,
      };

    case USER.EDIT_USER_SELF: {
      const { user } = action;
      if (!user) return state;

      return {
        ...state,
        user: { ...state.user, ...user },
      };
    }

    case AUTH.LOGIN_FAILURE:
      return { ...state, loggedIn: false, loggingIn: false };

    case AUTH.LOGOUT:
      return { ...state, user: null, loggedIn: false };

    case USER_PREFERENCES.UPDATE: {
      const { sectionId, configId, configValue } = action;
      const userPreferences = _.cloneDeep(state.user.userPreferences || {});

      if (!(sectionId in userPreferences)) return;

      for (const key in userPreferences) {
        if (configId in userPreferences[key]) {
          userPreferences[key][configId] = configValue;
        }
      }

      return {
        ...state,
        user: { ...state.user, userPreferences },
      };
    }

    case USER_PREFERENCES.FETCH_FULFILLED:
      return {
        ...state,
        user: { ...state.user, userPreferences: action.userPreferences },
        fetching: false,
      };

    case NOTIFICATION.FETCH_NOTIFICATIONS_FULFILLED:
      return {
        ...state,
        fetching: false,
        user: {
          ...state.user,
          notifications: action.payload,
        },
      };

    case NOTIFICATION.ADD_NOTIFICATION:
      return {
        ...state,
        user: {
          ...state.user,
          notifications: [...state.user.notifications, action.payload],
        },
      };

    case NOTIFICATION.DISMISS_NOTIFICATION:
      return {
        ...state,
        user: {
          ...state.user,
          notifications: state.user.notifications.filter(
            (n) => n.notificationId !== action.notificationId
          ),
        },
      };

    case NOTIFICATION.BATCH_DISMISS_NOTIFICATIONS:
      return {
        ...state,
        user: {
          ...state.user,
          notifications: state.user.notifications.filter(
            (n) => !action.notificationIds.includes(n.notificationId)
          ),
        },
      };

    case USER.FETCH_PROJECT_ROLES_FULFILLED:
      const { payload } = action;
      return {
        ...state,
        user: {
          ...state.user,
          projectRoles: payload,
        },
        fetching: false,
      };

    default:
      return state;
  }
};
